import $ from 'jquery'

$(document).ready(function () {
  dhsv_vc_news_archive_grid()
})

function dhsv_vc_news_archive_grid() {
  $('.dhsv_vc_news_archive_grid').each(function () {
    $('#news-archive-load-more').on('click tap', function () {
      if ($('.news-archive-grid-item-hidden').length) {
        $('.news-archive-grid-item-hidden')
          .slice(0, 6)
          .removeClass('news-archive-grid-item-hidden')
        if (!$('.news-archive-grid-item-hidden').length) {
          $(this).slideUp()
        }
      } else {
        $(this).slideUp()
      }
    })
  })
}
